import { render, staticRenderFns } from "./ApplyClaim.vue?vue&type=template&id=af20f32e&"
import script from "./ApplyClaim.vue?vue&type=script&lang=js&"
export * from "./ApplyClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports